<template>
    <div class="w-100">
        <div :class="$tachyons.topBar" class="z-999">
            <div :class="$tachyons.topBarInner + ' ' + claseBorde">
                <div class="h-100 flex">
                    <slot name="logo"></slot>
                    <div class="flex items-center w3 menu-iconos justify-start h-100 bg-white" v-if="notificaciones">
                        <router-link to="notificaciones" class="min-h-100 flex items-center ph3 hover-bg-light-gray tc bl br b--light-gray">
                            <div class="relative" v-if="conteo">
                                <div class="notificaciones w1 h1 bg-red white f6 absolute br-100 flex items-center justify-center"><span>{{conteo}}</span></div>
                            </div>
                            <img class="w2" :src="'img/icons/bell.svg'" />
                        </router-link>
                    </div>
                    <div class="flex items-center w3 menu-iconos justify-start h-100 bg-white" v-if="atras_.to">
                        <router-link :to="atras_.to" class="min-h-100 flex items-center ph3 hover-bg-light-gray tc bl br b--light-gray">
                            <img v-if="atras_.icono" class="w2" :src="'img/icons/' + atras_.icono + '.svg'" />
                            <img v-else class="w2" :src="'img/icons/back.svg'" />
                        </router-link>
                    </div>
                    <div class="flex flex-column justify-center tl h-100 pl2" style="min-width: 150px;">
                        <h3 v-show="titulo" class="mv1">{{titulo}}</h3>
                        <span v-show="subtitulo" class="mv0">{{subtitulo}}</span>
                    </div>
                </div>
                <div class="h-100 flex">
                    <div class="flex items-center w3 menu-iconos justify-end h-100 bg-white">
                        <router-link :to="accion_secundaria.to" class="min-h-100 flex items-center ph3 hover-bg-light-gray tc bl b--light-gray" v-if="accion_secundaria.to">
                            <img v-if="accion_secundaria.icono" class="w2" :src="'img/icons/' + accion_secundaria.icono + '.svg'" />
                            <img v-else class="w2" :src="'img/icons/gear.svg'" />
                        </router-link>
                        <router-link :to="accion.to" class="min-h-100 flex items-center ph3 hover-bg-light-gray tc bl br b--light-gray" v-if="accion.to">
                            <img v-if="accion.icono" class="w2" :src="'img/icons/' + accion.icono + '.svg'" />
                            <inline-svg v-else class="w2 fill-green" src="img/icons/plus.svg" />
                        </router-link>
                        <div @click="boton.funcion" class="min-h-100 flex items-center ph3 hover-bg-light-gray tc bl br b--light-gray pointer" v-if="boton.funcion">
                            <img v-if="boton.icono" class="w2" :src="'img/icons/' + boton.icono + '.svg'" />
                            <img v-else class="w2" src="img/icons/gear.svg" />
                        </div>
                    </div>
                    <slot name="personalizado">
                    </slot>
                </div>
            </div>
        </div>
        <div class="h3"></div>
    </div>
</template>
<script>
    import api from '@/api'
    import tools from '@/tools'

    export default {
        name: 'barra',
        props: {
            notificaciones: {
                type: Boolean,
                default: () => false,
            },
            borde: {
                type: String,
                default: ''
            },
            atras: {
                type: Object,
                default: () => { return {}; },
            },
            accion: {
                type: Object,
                default: () => { return {}; },
            },
            accion_secundaria: {
                type: Object,
                default: () => { return {}; },
            },
            boton: {
                type: Object,
                default: () => { return {}; },
            },
            titulo: {
                type: String,
                default: ''
            },
            subtitulo: {
                type: String,
                default: ''
            },
        },
        mounted () {
            var permiso_implicito = this.$store.state.permisos['notificaciones.index'];
            var permiso_explicito = this.$store.state.permitir_notificaciones;
            if (permiso_implicito || permiso_explicito) {
                api.get(
                    '/notificaciones/?conteo=1',
                    (success) => {
                        this.conteo = success.data.conteo;
                        try {
                            if (this.conteo) {
                                window.navigator.setAppBadge(this.conteo);
                            } else {
                                window.navigator.clearAppBadge(unreadCount);
                            }
                        } catch (error) {
                        }
                    }
                )
            }
            this.reemplazarAtras();
        },
        methods: {
            reemplazarAtras () {
                if (this.$route.query.atras) {
                    this.atras_.to = this.$route.query.atras;
                } else {
                    this.atras_ = this.atras;
                }
            },
        },
        computed:{
            claseBorde () {
                return  this.borde ? 'bb bw2 b--light-' + this.borde : ''
            },
        },
        data () {
            return {
                tools: tools,
                conteo: 0,
                atras_ : {
                    to: null,
                },
            }
        },
    }
</script>

